import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { User } from '../../types/auth.types';
import { useSTKContext } from '@/context/context';

export const useUser = (enabled: boolean, loginId: string) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<User>>({
    queryKey: ['user', loginId],
    queryFn: () => apiClient.get<User>(`/users/${loginId}`),
    enabled,
  });
};

export const useUsers = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<User[]>>({
    queryKey: ['users'],
    queryFn: () => apiClient.get<User[]>(`/users`),
    enabled,
  });
};

export const useFranchiseePortalUsers = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<User[]>>({
    queryKey: ['franchisee-portal-users'],
    queryFn: () => apiClient.get<User[]>(`/franchisee-portal-users`),
    enabled,
  });
};

export const useCurrentUser = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<User>>({
    queryKey: ['current-user'],
    queryFn: () => apiClient.get<User>(`/current-user`),
    enabled,
  });
};

export const useOrgUsers = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<User[]>>({
    queryKey: ['org', 'users'],
    queryFn: () => apiClient.get<User[]>(`/org/users`),
    enabled,
  });
};
